export default Object.freeze([
    {
        id: 1,
        value: 'Partnership',
        disabled: false
    },
    {
        id: 2,
        value: 'Sole Proprietorship',
        disabled: true
    },
    {
        id: 3,
        value: 'Limited Liability Corporation',
        disabled: false
    },
    {
        id: 4,
        value: 'Corporation',
        disabled: false
    },
    {
        id: 5,
        value: 'Co-operative',
        disabled: false
    },
    {
        id: 6,
        value: 'Non-profit Corporation',
        disabled: false
    },
])
